import React from "react";
import { Row, Col, Table } from "reactstrap";
import { FormattedDate } from "react-intl";
import MediaQuery from "react-responsive";
import style from "../../../Modal/Invoice/style.module.scss";
import { CustomFormInput } from "../../../../utils/FormFields";
import { formattedNumber } from "../../../FormattedNumber/FormattedNumber";

const Invoice = ({ invoiceInfo, opsViewAccountName }) => (
  <React.Fragment>
    <Row>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Concept">{invoiceInfo.ConceptName}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Invoice type">{invoiceInfo.InvoiceType}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Currency">{invoiceInfo.CurrencyISO}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Sett. Date">
          <FormattedDate value={invoiceInfo.InvoiceSetllementDate + "T00:00"} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Invoice id">{invoiceInfo.InvoiceId}</CustomFormInput>
      </Col>
      {invoiceInfo.InvoiceStatus === "PartiallyBooked" && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Sett. Date">
            <FormattedDate value={invoiceInfo.InvoiceTradeDate + "T00:00"} />
          </CustomFormInput>
        </Col>
      )}
      {invoiceInfo.InvoiceClientName && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Client">{invoiceInfo.InvoiceClientName}</CustomFormInput>
        </Col>
      )}
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Invoice Date">
          <FormattedDate value={invoiceInfo.InvoiceDate + "T00:00"} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Status">{invoiceInfo.InvoiceStatus}</CustomFormInput>
      </Col>
      {invoiceInfo.InvoiceClientTaxId && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="RUT">{invoiceInfo.InvoiceClientTaxId}</CustomFormInput>
        </Col>
      )}
      {invoiceInfo.InvoiceAccountNumber && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Account Number">{invoiceInfo.InvoiceAccountNumber}</CustomFormInput>
        </Col>
      )}
      <Col xs={6} md={4} lg={3}>
        {opsViewAccountName == undefined ?
        (
          <CustomFormInput label="Account Name">
            {invoiceInfo.InvoiceAccountName}
          </CustomFormInput>
        )
        :
        (
          opsViewAccountName ?
          (
            <CustomFormInput label="Account Name">
              {invoiceInfo.InvoiceAccountName}
            </CustomFormInput>
          )
          :
          (
            ""
          )
        )
        }
      </Col>
      {invoiceInfo.InvoiceCounterPartyName && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Counter Party Name">{invoiceInfo.InvoiceCounterPartyName}</CustomFormInput>
        </Col>
      )}
      {invoiceInfo.InvoiceClientAddress && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Address">{invoiceInfo.InvoiceClientAddress}</CustomFormInput>
        </Col>
      )}
      {invoiceInfo.InvoiceBankAccountName && (
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Bank Account">{invoiceInfo.InvoiceBankAccountName}</CustomFormInput>
        </Col>
      )}
    </Row>
    <Row className="my-3">
      {invoiceInfo.line && invoiceInfo.line.length > 0 && <Lines lines={invoiceInfo.line} />}
    </Row>
    <Row>
      <Col>
        <CustomFormInput label="Description">{invoiceInfo.InvoiceDescription}</CustomFormInput>
        <CustomFormInput label="Addendum">{invoiceInfo.InvoiceAddendum}</CustomFormInput>
      </Col>
      <Col>
        <Totals i={invoiceInfo} />
      </Col>
    </Row>
  </React.Fragment>
);

const Totals = ({ i }) => (
  <div className={style.totals}>
    <Row className="mx-3">
      <CustomFormInput label="Sub Total">{formattedNumber(i.InvoiceSubtotal, "currency")}</CustomFormInput>
    </Row>
    <Row className="mx-3">
      <CustomFormInput label="Tax">{formattedNumber(i.InvoiceTax, "currency")}</CustomFormInput>
    </Row>
    <Row className="mx-3">
      <CustomFormInput label="Total">{formattedNumber(i.InvoiceTotal, "currency")}</CustomFormInput>
    </Row>
  </div>
);

const Lines = ({ lines }) => (
  <Table className={style.table} striped>
    <thead>
      <tr>
        <th style={{ width: "35%" }}>Description</th>
        <MediaQuery minWidth={700}>
          {(matches) =>
            matches ? (
              <React.Fragment>
                <th className="text-center" style={{ width: "13%" }}>
                  Commission
                </th>
                <th className="text-center" style={{ width: "13%" }}>
                  Tax Type
                </th>
                <th className="text-center" style={{ width: "13%" }}>
                  Tax
                </th>
              </React.Fragment>
            ) : null
          }
        </MediaQuery>
        <th className="text-center" style={{ width: "13%" }}>
          Total
        </th>
      </tr>
    </thead>
    <tbody>
      {lines &&
        lines.length > 0 &&
        lines.map((line, index) => <Line key={`line-${line.id}`} index={index} line={line} />)}
    </tbody>
  </Table>
);

const Line = ({ line }) => (
  <tr className={style.line}>
    <td>{line.InvoiceLineDescription}</td>
    <MediaQuery minWidth={700}>
      {(matches) =>
        matches ? (
          <React.Fragment>
            <td className="text-center">{formattedNumber(line.InvoiceLineCommission, "currency")}</td>
            <td className="text-center">{line.InvoiceLineTaxName}</td>
            <td className="text-center">{formattedNumber(line.InvoiceLineTax, "currency")}</td>
          </React.Fragment>
        ) : null
      }
    </MediaQuery>
    <td className="text-center">{formattedNumber(line.InvoiceLineTotal, "currency")}</td>
  </tr>
);

export default Invoice;
